import { Module } from "vuex";
import { RootState } from "../types";
import { StripesInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  stripes: [],
} as StripesInt;

export const stripes: Module<StripesInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
